import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function getParamString(
  key: string,
  value: string | null,
  search: string | undefined,
): string {
  const params = new URLSearchParams(search);
  if (value === null || value === undefined) {
    params.delete(key);
  } else {
    params.set(key, value);
  }
  return params.toString();
}

/**
 * Extracts query parameters from the current URL and provides a setter to update them.
 *   const { query, setQuery } = useQuery();
 *   const searchTerm = query.get("term");               // Gets "cats" from "?term=cats&page=2"
 *   setQuery("term", "dogs");                           // Updates to "?term=dogs&page=2"
 *   setQuery("filters", JSON.stringify(activeFilters)); // Stores JSON in query string
 *   setQuery("filters", null);                          // Removes the "filters" param
 */
export function useQuery() {
  const { search } = useLocation();
  const navigate = useNavigate();

  const query = useMemo(() => new URLSearchParams(search), [search]);

  const setQuery = (key: string, value: string | null) => {
    const paramString = getParamString(key, value, search);
    navigate({ search: paramString }, { replace: true });
  };

  return { query, setQuery };
}
